/**
 * Get the localized route path.
 *
 * @util
 * @param path - The path of the route.
 * @param locale - The locale string (e.g., 'us', 'pl', 'pl-en').
 * @returns The localized route path.
 * @__NO_SIDE_EFFECTS__
 */
export function getLocalizedRoutePath(path, locale) {
    return `/${locale}${path}`;
}
//# sourceMappingURL=getLocalizedRoutePath.js.map